<template>
<v-menu offset-y>
  <template v-slot:activator="{ on: menu }">
    <v-tooltip bottom>
      <template v-slot:activator="{ on: tooltip }">
        <v-btn
          icon medium
          v-on="{ ...tooltip, ...menu }"
          :loading="isFetching"
          @click="getTransportRequestData"
        >
          <v-icon color="#757575">local_printshop</v-icon>
        </v-btn>
      </template>
      <span>{{$t('print_files.export_order_list')}}</span>
    </v-tooltip>
    </template>
    <v-list v-if="!isFetching">
      <v-list-item @click="exportPdf">
        <v-list-item-title>PDF</v-list-item-title>
      </v-list-item>
    </v-list>
</v-menu>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import jsPDF from 'jspdf'
import 'jspdf-autotable'
import Roboto from '@/assets/fonts/Roboto-Regular-normal.js'
import RobotoBold from '@/assets/fonts/Roboto-Bold-bold.js'

export default {
  name: 'ExportOrderList',
  components: {},
  props: {},
  data () {
    return {
        loading: false,
    }
  },
  computed: {
    ...mapGetters({
      getSelectedResource: 'getSelectedResource',
      getSelectedResourceID: 'getSelectedResourceID',
      getTransportData: 'exportData/getTransportData',
      getIsFetching: 'exportData/getIsFetching'
    }),
    isFetching () {
      return this.getIsFetching
    },
    transportData () {
      return this.getTransportData
    }
  },
  methods: {
    ...mapActions({
      fetchTransportRequestData: 'exportData/fetchTransportRequestData'
    }),
    getTransportRequestData () {
      this.fetchTransportRequestData({ transportID: this.getSelectedResourceID })
    },
    exportPdf () {
      this.loading = true
      // console.log(this.transportData)
      // console.log(this.getSelectedResource)
      let doc = new jsPDF()
      doc.addFileToVFS('Roboto-Regular.ttf', Roboto)
      doc.addFileToVFS('Roboto-Bold.ttf', RobotoBold)
      doc.addFont('Roboto-Regular.ttf', 'Roboto', 'normal')
      doc.addFont('Roboto-Bold.ttf', 'Roboto', 'bold')
      doc.setFont('Roboto')
      doc.setFontSize(11)
      doc.setFontStyle('bold')
      doc.text(this.$i18n.tc('transport_request.transport_request', 1) + ' - ' + this.transportData.ref, 10, 10)
      // priority
      doc.setFontSize(10)
      doc.setFontStyle('normal')
      // priority
      if (this.transportData.priority) {
        doc.text(this.$i18n.t('orders.priority') + ': ' + this.$i18n.t('priorities.' + this.transportData.priority), 12, 18)
      } else {
        doc.text(this.$i18n.t('orders.priority') + ': ' + this.$i18n.t('priorities.Medium'), 12, 18)
      }
      // status
      if (this.transportData.status) {
        doc.text(this.$i18n.tc('orders.status') + ': ' + this.transportData.status, 110, 18)
      } else {
        doc.text(this.$i18n.tc('orders.status') + ': n/a', 110, 18)
      }
      // incoterms
      if (this.transportData.incoterms) {
        doc.text(this.$i18n.tc('orders.incoterms') + ': ' + this.transportData.incoterms, 12, 23)
      } else {
        doc.text(this.$i18n.tc('orders.incoterms') + ': n/a', 12, 23)
      }

      // pick up and delivery
      doc.setFontStyle('bold')
      doc.text(this.$i18n.t('orders.origin'), 12, 30)
      doc.text(this.$i18n.t('orders.destination'), 110, 30)
      doc.setFontStyle('normal')
      doc.text(this.$i18n.t('orders.company'), 12, 38)
      doc.text(this.$i18n.t('orders.company'), 110, 38)
      if (this.transportData.origin.organization.name) {
        this.fieldLineSplit(doc, this.transportData.origin.organization.name, 14, 47, 14, 44, 14, 47, 14, 50)
      } else {
        doc.text('n/a', 14, 46)
      }
      if (this.transportData.destination.organization.name) {
        this.fieldLineSplit(doc, this.transportData.destination.organization.name, 112, 47, 112, 44, 112, 47, 112, 50)
      } else {
        doc.text('n/a', 112, 46)
      }
      // this.fieldLineSplit(doc, this.order.originAddress.company, 14, 47, 14, 44, 14, 47, 14, 50)
      // this.fieldLineSplit(doc, this.order.destinationAddress.company, 112, 47, 112, 44, 112, 47, 112, 50)
      doc.rect(12, 40, 90, 12, 'S')
      doc.rect(110, 40, 95, 12, 'S')
      doc.text(this.$i18n.t('orders.location_pickup'), 12, 58)
      doc.text(this.$i18n.t('orders.location_delivery'), 110, 58)
      this.fieldLineSplit(doc, `${this.transportData.origin.address.street} ${this.transportData.origin.address.streetNo}, ${this.transportData.origin.address.postalCode} ${this.transportData.origin.address.city}, ${this.transportData.origin.address.country}`, 14, 67, 14, 64, 14, 67, 14, 70)
      this.fieldLineSplit(doc, `${this.transportData.destination.address.street} ${this.transportData.destination.address.streetNo}, ${this.transportData.destination.address.postalCode} ${this.transportData.destination.address.city}, ${this.transportData.destination.address.country}`, 112, 67, 112, 64, 112, 67, 112, 70)
      doc.rect(12, 60, 90, 12, 'S')
      doc.rect(110, 60, 95, 12, 'S')
      doc.text(this.$i18n.t('orders.contact_origin'), 12, 78)
      doc.text(this.$i18n.t('orders.contact_destination'), 110, 78)
      if (this.transportData.origin.contactPersons === null) {
        doc.text('n/a', 14, 87)
      } else {
        this.fieldLineSplit(doc, this.transportData.origin.contactPersons, 14, 87, 14, 84, 14, 87, 14, 90)
      }
      if (this.transportData.destination.contactPersons === null) {
        doc.text('n/a', 112, 87)
      } else {
        this.fieldLineSplit(doc, this.transportData.destination.contactPersons, 112, 87, 112, 84, 112, 87, 112, 90)
      }
      doc.rect(12, 80, 90, 12, 'S')
      doc.rect(110, 80, 95, 12, 'S')
      doc.text(this.$i18n.t('orders.ref_number'), 12, 98)
      doc.text(this.$i18n.t('orders.ref_number'), 110, 98)
      if (this.transportData.origin.ref === '') {
        doc.text('n/a', 14, 107)
      } else {
        this.fieldLineSplit(doc, this.transportData.origin.ref, 14, 107, 14, 104, 14, 107, 14, 110)
      }
      if (this.transportData.destination.ref === '') {
        doc.text('n/a', 112, 107)
      } else {
        this.fieldLineSplit(doc, this.transportData.destination.ref, 112, 107, 112, 104, 112, 107, 112, 110)
      }
      // loading time
      doc.rect(12, 100, 90, 12, 'S')
      doc.rect(110, 100, 95, 12, 'S')
      doc.text(this.$i18n.t('orders.open_hours_origin'), 12, 118)
      doc.text(this.$i18n.t('orders.open_hours_destination'), 110, 118)
      doc.text(`${this.$i18n.t('orders.from')}: ${this.$options.filters.timeToReadableTz(this.transportData.pickup.from, this.$i18n.locale)}`, 15, 124)
      doc.text(`${this.$i18n.t('orders.to')}: ${this.$options.filters.timeToReadableTz(this.transportData.pickup.to, this.$i18n.locale)}`, 45, 124)
      doc.text(`${this.$i18n.t('orders.from')}: ${this.$options.filters.timeToReadableTz(this.transportData.delivery.from, this.$i18n.locale)}`, 112, 124)
      doc.text(`${this.$i18n.t('orders.to')}: ${this.$options.filters.timeToReadableTz(this.transportData.delivery.to, this.$i18n.locale)}`, 142, 124)
      // loading date
      doc.text(this.$i18n.t('orders.date_origin'), 12, 135)
      doc.text(this.$i18n.t('orders.date_destination'), 110, 135)
      doc.text(this.$i18n.t('orders.from') + ': ' + this.$options.filters.dateToReadableTz(this.transportData.pickup.from, this.$i18n.locale), 15, 140)
      doc.text(this.$i18n.t('orders.to') + ': ' + this.$options.filters.dateToReadableTz(this.transportData.pickup.to, this.$i18n.locale), 55, 140)
      doc.text(this.$i18n.t('orders.from') + ': ' + this.$options.filters.dateToReadableTz(this.transportData.delivery.from, this.$i18n.locale), 113, 140)
      doc.text(this.$i18n.t('orders.to') + ': ' + this.$options.filters.dateToReadableTz(this.transportData.delivery.to, this.$i18n.locale), 153, 140)

      // transport details
      doc.setFontSize(11)
      doc.setFontStyle('bold')
      doc.text(this.$i18n.t('orders.transport_details'), 10, 160)
      doc.setFontSize(10)
      doc.setFontStyle('normal')
      doc.text(this.$i18n.t('orders.vehicle_restirction.title'), 12, 170)
      if (this.transportData.restrictions.vehicle.includes('HydraulicFront')) {
        doc.rect(12, 175, 4, 4, 'S')
        doc.rect(13, 176, 2, 2, 'F')
      } else {
        doc.rect(12, 175, 4, 4, 'S')
      }
      doc.text(this.$i18n.t('orders.hydraulic_front'), 20, 178)
      if (this.transportData.restrictions.vehicle.includes('HydraulicArm')) {
        doc.rect(12, 185, 4, 4, 'S')
        doc.rect(13, 186, 2, 2, 'F')
      } else {
        doc.rect(12, 185, 4, 4, 'S')
      }
      doc.text(this.$i18n.t('orders.hydraulic_arm'), 20, 188)
      if (this.transportData.restrictions.vehicle.includes('Tipper')) {
        doc.rect(12, 195, 4, 4, 'S')
        doc.rect(13, 196, 2, 2, 'F')
      } else {
        doc.rect(12, 195, 4, 4, 'S')
      }
      doc.text(this.$i18n.t('orders.tipper'), 20, 198)
      if (this.transportData.restrictions.vehicle.includes('SlidingFloor')) {
        doc.rect(12, 203, 4, 4, 'S')
        doc.rect(13, 204, 2, 2, 'F')
      } else {
        doc.rect(12, 203, 4, 4, 'S')
      }
      doc.text(this.$i18n.t('orders.sliding_floor'), 20, 206)
      if (this.transportData.restrictions.vehicle.includes('AntiSlipFloor')) {
        doc.rect(12, 211, 4, 4, 'S')
        doc.rect(13, 212, 2, 2, 'F')
      } else {
        doc.rect(12, 211, 4, 4, 'S')
      }
      doc.text(this.$i18n.t('orders.anti_slip_floor'), 20, 214)

      doc.text(this.$i18n.t('orders.cargo_restirction.title'), 80, 170)
      if (this.transportData.restrictions.cargo.includes('CooledAboveZero')) {
        doc.rect(82, 175, 4, 4, 'S')
        doc.rect(83, 176, 2, 2, 'F')
      } else {
         doc.rect(82, 175, 4, 4, 'S')
      }
      doc.text(this.$i18n.t('orders.cargo_restirction.CooledAboveZero'), 90, 178)
      if (this.transportData.restrictions.cargo.includes('FrozenGoods')) {
        doc.rect(82, 185, 4, 4, 'S')
        doc.rect(83, 186, 2, 2, 'F')
      } else {
         doc.rect(82, 185, 4, 4, 'S')
      }
      doc.text(this.$i18n.t('orders.cargo_restirction.FrozenGoods'), 90, 188)
         if (this.transportData.restrictions.cargo.includes('DangerousGoods')) {
        doc.rect(82, 195, 4, 4, 'S')
        doc.rect(83, 196, 2, 2, 'F')
      } else {
         doc.rect(82, 195, 4, 4, 'S')
      }
      doc.text(this.$i18n.t('orders.cargo_restirction.DangerousGoods'), 90, 198)
      if (this.transportData.restrictions.cargo.includes('ContainsLiIon')) {
        doc.rect(82, 203, 4, 4, 'S')
        doc.rect(83, 204, 2, 2, 'F')
      } else {
         doc.rect(82, 203, 4, 4, 'S')
      }
      doc.text(this.$i18n.t('orders.cargo_restirction.ContainsLiIon'), 90, 206)

      doc.text(this.$i18n.t('orders.location_restirction.title'), 140, 170)
      if (this.transportData.restrictions.location.includes('HYDRAULIC_RAMP')) {
        doc.rect(142, 175, 4, 4, 'S')
        doc.rect(143, 176, 2, 2, 'F')
      } else {
        doc.rect(142, 175, 4, 4, 'S')
      }
      doc.text(this.$i18n.t('orders.location_restirction.HYDRAULIC_RAMP'), 150, 178)
      if (this.transportData.restrictions.location.includes('FORKLIFT')) {
        doc.rect(142, 185, 4, 4, 'S')
        doc.rect(143, 186, 2, 2, 'F')
      } else {
        doc.rect(142, 185, 4, 4, 'S')
      }
      doc.text(this.$i18n.t('orders.location_restirction.FORKLIFT'), 150, 188)
      if (this.transportData.restrictions.location.includes('PALLET_TRUCK')) {
        doc.rect(142, 195, 4, 4, 'S')
        doc.rect(143, 196, 2, 2, 'F')
      } else {
        doc.rect(142, 195, 4, 4, 'S')
      }
      doc.text(this.$i18n.t('orders.location_restirction.PALLET_TRUCK'), 150, 198)
          if (this.transportData.restrictions.location.includes('CRANE')) {
        doc.rect(142, 203, 4, 4, 'S')
        doc.rect(143, 204, 2, 2, 'F')
      } else {
        doc.rect(142, 203, 4, 4, 'S')
      }
      doc.text(this.$i18n.t('orders.location_restirction.CRANE'), 150, 206)
      
      // // labels
      // doc.setFontSize(11)
      // doc.setFontStyle('bold')
      // doc.text(this.$i18n.t('orders.labels'), 10, 230)
      // doc.setFontSize(10)
      // doc.setFontStyle('normal')

       // comment
      doc.setFontSize(11)
      doc.setFontStyle('bold')
      doc.text(this.$i18n.t('orders.comment_2'), 10, 230)
      doc.setFontSize(10)
      doc.setFontStyle('normal')
      if (this.transportData.comment === '') {
        doc.text('n/a', 12, 235)
      } else {
        doc.text(this.transportData.comment, 10, 235)
      }

      // items
      doc.addPage()
      doc.setFontSize(12)
      doc.setFontStyle('bold')
      doc.text(this.$i18n.tc('transport_request.transport_request', 1) + ' - ' + this.transportData.ref + ' - ' + this.$i18n.t('orders.order_items'), 10, 10)
      let body = []

      for (let i = 0; i < this.transportData.units.length; i++) {
        let itemType = this.transportData.units[i].type
        let length = this.transportData.units[i].dimensions.length + ' cm'
        let width = this.transportData.units[i].dimensions.width + ' cm'
        let height = this.transportData.units[i].dimensions.height + ' cm'
        let weight = this.transportData.units[i].weight + ' kg'
        let status = this.transportData.units[i].status
        // let stockable
        // if (this.order.cargos[i].stockable) {
        //   stockable = this.$i18n.t('orders.yes')
        // } else {
        //   stockable = this.$i18n.t('orders.no')
        // }
        body.push([itemType, length, width, height, weight, status])
      }
      doc.autoTable({
        head: [
          [
            { content: this.$i18n.t('orders.item_type') },
            { content: this.$i18n.t('orders.length') },
            { content: this.$i18n.t('orders.width') },
            { content: this.$i18n.t('orders.height') },
            { content: this.$i18n.t('orders.weight') },
            { content: this.$i18n.t('orders.status') },
          ]
        ],
        body: body,
        styles: { fontSize: 10, textColor: [33, 33, 33] },
        theme: 'grid',
        rowPageBreak: 'avoid',
        headStyles: { fillColor: [255, 255, 255], lineWidth: 0.1 }
      })
      try {
        doc.save(`transport_request_${this.transportData.ref}.pdf`)
      } catch (err) {
        Sentry.captureException(err)
      }
      
      this.loading = false
    },
    fieldLineSplit (doc, sentence, x, y, xFirst, yFirst, xSec, ySec, xThird, yThird) {
      // checks the length of the field string and splits in two or three
      if (sentence.length <= 55) {
        doc.text(sentence, x, y)
      } else if (sentence.length > 55 && sentence.length <= 99) {
        doc.setFontSize(9)
        let firstHalf = sentence.slice(0, 55)
        let secondHalf = sentence.slice(55)
        doc.text(firstHalf, xFirst, yFirst)
        doc.text(secondHalf, xSec, ySec)
      } else if (sentence.length > 100) {
        let firstHalf = sentence.slice(0, 55)
        let secondHalf = sentence.slice(55, 112)
        let thirdHalf = sentence.slice(113)
        doc.text(firstHalf, xFirst, yFirst)
        doc.text(secondHalf, xSec, ySec)
        doc.text(thirdHalf, xThird, yThird)
      }
    }
  },
}
</script>

<style lang="scss" scoped>

</style>
